import { useQuery } from '@apollo/client'
import { mockExamsPlatformClient } from 'apollo-client'
export const useMockExamsPlatformQuery = (query, options) => {
  return useQuery(query, {
    ...options,
    client: mockExamsPlatformClient,
  })
}
